module.exports = __webpack_public_path__ + "img/banner.6574975d.png";